import Briefcase from "../../Icons/Briefcase";
import Collection from "../../Icons/Collection";
import Presentation from "../../Icons/Presentation";
import Dollor from "../../Icons/Dollor";
import ChevronRight from "../../Icons/ChevronRight";
import {
  SectionContainerBase,
  TwoColumnSectionBase,
  CenteredGridBase,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";

let firstSectionData = {
  title: "Why Choose Auction Bazaar",
  description:
    "One Stop Auction Destination. Come and experience a beautiful alliance with the country’s most trusted auctioneers under one roof. Bidding has never been easier!",
  actions: (
    <div className="text-lg text-blue-500">
      <a href="#" className="flex items-center gap-x-2">
        Learn More <ChevronRight />
      </a>
    </div>
  ),
};

const Icon = (props: any) => {
  return (
    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-900 text-white">
      {props.iconObject}
    </div>
  );
};

const items = [
  {
    title: "Transparent Process",
    description:
      "We provide a transparent platform for Banks and Finance companies to list their NPAs and find potential bidders without intermediaries.",
    icon: <Icon iconObject={<Presentation />} />,
  },
  {
    title: "Expert Consultation",
    description:
      "Our expert teams are available for personal phone/chat assistance to ensure that the bidders don't face hiccups throughout their journey.",
    icon: <Icon iconObject={<Briefcase />} />,
  },
  {
    title: "Dedicated Relationship Managers",
    description:
      "We understand that personal assistance might be needed in your bidding journey. That is why we assign a dedicated relationship manager for end-to-end handling of transactions.",
    icon: <Icon iconObject={<Collection />} />,
  },
  {
    title: "Financing Assistance",
    description:
      "We will structure an exceptional finance package with various alternate modes and assist potential investors with up to 60% of the bid value. We have partnered exclusively with NBFC/FI's/Banks to facilitate smooth funding of NPAs.",
    icon: <Icon iconObject={<Dollor />} />,
  },
];

const FirstSection = (props: any) => {
  return (
    <IconTitleDescriptionActionCard
      title={firstSectionData.title}
      description={firstSectionData.description}
      actions={firstSectionData.actions}
      iconPosition="top-left"
      itemTitleDescriptionCardBaseClasses={{
        iconWrapper:
          "flex h-12 w-12 items-center justify-center rounded-md text-white",
        titleWrapper: "mt-2 text-left",
        titleStyles:
          "w-60 text-3xl font-extrabold tracking-tight text-white sm:text-4xl ",
        descriptionWrapper: "text-left mt-2",
        descriptionStyles: "text-base text-white",
        actionWrapper: "mt-2 text-left text-blue-600",
      }}
    />
  );
};

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            iconPosition="top-left"
            itemTitleDescriptionCardBaseClasses={{
              iconWrapper:
                "flex h-12 w-12 items-center justify-center rounded-md text-white",
              titleWrapper: "mt-5 text-left",
              titleStyles: "text-lg leading-6 font-medium text-white",
              descriptionWrapper: "text-left mt-2",
              descriptionStyles: "text-base text-gray-400",
              actionWrapper: "mt-2 text-left",
            }}
          />
        );
      })}
    </>
  );
};

const SecondSection = (props: any) => {
  return (
    <CenteredGridBase
      items={items}
      itemsRenderer={ItemRendererComponent}
      centeredGridBaseClasses={{
        gridClasses:
          "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10",
      }}
    />
  );
};

export default function WhyChooseComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20 bg-slate-900 overflow-hidden",
        innerContainerStyles: "relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={<FirstSection />}
        secondColumnEl={<SecondSection />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full md:w-1/4",
          secondElWrapperStyles: "w-full md:w-3/4 self-stretch md:pl-16",
          columnsFlexWrapperStyles:
            "flex items-center  justify-between flex-col md:flex-row",
        }}
      />
    </SectionContainerBase>
  );
}
